import { z } from 'zod';
import { isNumber } from 'radash';

const validator = z.preprocess((value) => {
    if (!isNumber(value)) {
        return 1;
    }

    if (value < -1) {
        return -1;
    }

    return value > 1 ? 1 : value;
}, z.number().min(-1).max(1));

export const PowerFactor = {
    validator,
};

export type PowerFactor = z.infer<typeof validator>;
